import * as Network from "expo-network";

import type { NetworkStatus } from "@/schemas/diagnostics/network";

/**
 * Checks the current network status and internet connectivity
 * @returns Promise with network status information
 */
export const checkNetworkConnection = async (): Promise<NetworkStatus> => {
  try {
    const networkState = await Network.getNetworkStateAsync();

    return {
      isConnected: networkState.isConnected || false,
      isInternetReachable: networkState.isInternetReachable || false,
      details: networkState.isConnected
        ? `Connected via ${networkState.type}`
        : "No connection detected",
    };
  } catch (error) {
    // Fallback in case the network check fails
    return {
      isConnected: false,
      isInternetReachable: false,
      details: "Unable to determine network status",
    };
  }
};
